/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { useMatch, useLocation } from 'react-router-dom';
import menu from '../images/icons/menu.svg';
import close from '../images/icons/close.svg';

const HeaderMenu = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const matchHomeRoute = useMatch({ path: '/', exact: true });
  const location = useLocation();
  useEffect(() => {
    setMenuOpen(false)
  }, [location]);

  return (
    <>
      <div className="flex">
        <div className="absolute right-10 top-8 md:right-15 md:top-7 lg:right-24 lg:top-9 2xl:top-12 3xl:right-42 3xl:top-18 z-10">
          <img
            alt="show menu"
            className={`h-5 w-7.5 lg:h-6 lg:w-9 cursor-pointer default ${
              menuOpen ? 'hidden' : 'block'
            } `}
            src={menu}
            onClick={() => setMenuOpen(true)}
          />
          <img
            alt="hide menu"
            className={`h-5 w-7.5 md:w-5 lg:h-6 lg:w-6 cursor-pointer ${
              menuOpen ? 'block' : 'hidden'
            } `}
            src={close}
            onClick={() => setMenuOpen(false)}
          />
        </div>
        <ul
          className={`absolute bg-black bg-opacity-70 text-white font-Montserrat font-bold uppercase text-base divide-y space-y-2 w-full md:bg-opacity-0 md:divide-y-0 md:space-y-0 md:w-0 md:top-7 md:space-x-3 md:text-sm lg:text-xl lg:top-8 lg:space-x-5 2xl:top-12 3xl:text-2xl 3xl:top-16 ${
            menuOpen
              ? 'visible md:flex opacity-100 transform translate-full duration-300 ease-in-out top-0 md:right-114 lg:right-168 2xl:right-168 3xl:right-208'
              : 'invisible md:flex opacity-0 transform translate-0 duration-300 ease-in-out top-0 md:right-100 lg:right-154'
          }`}
        >
          <li
            className={`hover:underline pt-20 md:pt-0 ${
              matchHomeRoute ? 'invisible' : 'visible'
            } `}
          >
            <Link smooth to="/#services" className="pl-6 md:pl-0">
              Services
            </Link>
          </li>
          <li className="hover:underline pt-4 md:pt-0">
            <Link smooth to="/#about" className="pl-6 md:pl-0">
              About
            </Link>
          </li>
          <li className="hover:underline pt-4 md:pt-0">
            <Link smooth to="/#gallery" className="pl-6 md:pl-0">
              Gallery
            </Link>
          </li>
          <li className="hover:underline pt-4 md:pt-0">
            <Link smooth to="/#locations" className="pl-6 md:pl-0">
              Locations
            </Link>
          </li>
          <li className="hover:underline pt-4 pb-4 md:pt-0 md:pb-0">
            <Link smooth to="#contact" className="pl-6 md:pl-0">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default HeaderMenu;
